import React from 'react';
import { CustomizableHeader } from '../CustomizableHeader/CustomizableHeader';
import EventMenu from '@apps/guest/packages/layout-engine/components/EventMenu/EventMenu';
import { useEventInfo } from '@shared/utils/eventInfo';
import { NavbarEventPropsInterface } from '../../../layout.types';
import { LegacyHeader } from '../LegacyHeader/LegacyHeader';
import { useColorPaletteProvider } from '../../../ColorPaletteProvider/ColorPaletteProvider';
import { useWebsiteHeaderSettings } from '../../../hooks/useWebsiteHeaderSettings/useWebsiteHeaderSettings';

type TelemetryEditPhotoActions = {
  onChangePhotoButtonClicked: () => void;
  onEditPhotoOpenedChange: (opened: boolean) => void;
  onFocusPointChange: (prevPoint: unknown, newPoint: unknown) => void;
  onFocusPointChangeError: (error: unknown) => void;
};

type WebsiteHeaderProps = {
  eventDisplayName?: string | null;
  greeting?: string | null;
  artBackgroundFontColor?: string;
  telemetryEditPhotoActions: TelemetryEditPhotoActions;
  handleMenuOpenedChange: (isOpen: boolean) => void;
  handleMenuClicked: (pageClicked: string) => void;
  eventMenuProps: NavbarEventPropsInterface;
};

export const WebsiteHeader = ({
  eventDisplayName,
  greeting,
  artBackgroundFontColor,
  telemetryEditPhotoActions,
  handleMenuOpenedChange,
  handleMenuClicked,
  eventMenuProps,
}: WebsiteHeaderProps) => {
  const { eventHandle } = useEventInfo();
  const { websiteHeader } = useWebsiteHeaderSettings({
    eventHandle: eventHandle || '',
    targetWebsiteLayout: 'aloha',
  });
  const { pageColor } = useColorPaletteProvider();

  if (websiteHeader) {
    return (
      <CustomizableHeader
        eventHandle={eventHandle || ''}
        telemetryPhotoEditor={telemetryEditPhotoActions}
        websiteHeader={websiteHeader}
        fontColor={artBackgroundFontColor}
      >
        <EventMenu
          eventProps={eventMenuProps}
          handleMenuOpenedChange={handleMenuOpenedChange}
          handleMenuClicked={handleMenuClicked}
          title={eventDisplayName}
          eventHandle={eventHandle || ''}
          backgroundColor={pageColor}
        />
      </CustomizableHeader>
    );
  }

  return (
    <LegacyHeader
      eventHandle={eventHandle || ''}
      telemetryPhotoEditor={telemetryEditPhotoActions}
      title={eventDisplayName}
      subtitle={greeting}
    >
      <EventMenu
        eventProps={eventMenuProps}
        handleMenuOpenedChange={handleMenuOpenedChange}
        handleMenuClicked={handleMenuClicked}
        title={eventDisplayName}
        eventHandle={eventHandle || ''}
        backgroundColor={pageColor}
      />
    </LegacyHeader>
  );
};

WebsiteHeader.displayName = 'WebsiteHeader';
